import FieldInterpolation from  "../TableList/FieldInterpolation.vue";
export default {
  name: "ListItem",
  components: {
    FieldInterpolation
  },
  props: {
    itemList: {
      type: Array,
      required: true
    },
    pagination: {
      type: Object
    },
    styleClass: {
      type: Object,
      required: false,
      default: () => ({th:'border-0', td: ''})
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'string'
    },
    title: {
      type: String,
      required: false
    },
    showQuantity: {
      type: Boolean,
      default: false
    },
  },
  watch: {
    pagination() {
      this.$emit('update:pagination', this.pagination);
    },
    "pagination.PageNumber"() {
      this.$emit("List");
    },
    "pagination.RowsPerPage"() {
      this.$emit("List");
    }
  },
  computed:{
    totalItems(){
      return this.pagination != undefined ? this.pagination.TotalItems : this.itemList.length;
    }
  }
};


// WEBPACK FOOTER //
// ./src/components/sub-components/Generic/ListItem/ListItem.js